module.exports = __webpack_public_path__ + "static/media/location.35b59b59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/location.svg
// module id = 27
// module chunks = 0